module.exports = __webpack_public_path__ + "static/media/xfiles.f59f893.mid";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xfiles.mid
// module id = 8tMZ
// module chunks = 0